import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import PlusMiniSvg from "../../../../../../media/images/icons/plus-mini";
import ArrowTickDown from "../../../../../../media/images/icons/arrow-tick-down";

export default function TransactionCard() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <Box
      onClick={() => setOpen((prev) => !prev)}
      sx={{
        border: "1px solid gray",
        borderRadius: "16px",
        backgroundColor: "background.default",
        padding: "8px 8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <PlusMiniSvg size={28} color={theme.palette.success.main} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                color: "success.main",
              }}
            >
              شارژ حساب
            </Typography>
            <Typography
              sx={{
                fontSize: "10px",
              }}
            >
              1402/12/04 - 10:35 درگاه بانک سامان
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                color: "success.main",
              }}
            >
              200,000 ریال
            </Typography>
            <Typography
              sx={{
                fontSize: "11px",
              }}
            >
              موجودی نهایی: 60,000 ریال
            </Typography>
          </Box>
          <Box
            sx={{
              rotate: open ? "180deg" : "0deg",
              transition: "all 0.3s",
            }}
          >
            <ArrowTickDown color={theme.palette.info.main} size={12} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          height: open ? "180px" : "0px",
          borderRadius: "16px",
          overflow: "hidden",
          transition: "all 0.3s",
          mt: 1,
          backgroundColor: "info.light",
          paddingX: "8px",
          paddingY: open ? "8px" : "0px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.default",
            mx: "auto",
            borderRadius: "8px",
            py: 2,
          }}
        >
          <Typography
            sx={{
              color: "primary.main",
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            شماره رهگیری: 554544545454545454
          </Typography>
        </Box>
        <Box
          sx={{ mt: 2, display: "flex", flexDirection: "column", gap: "4px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              شماره کارت:
            </Typography>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              6219621962196219
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              تاریخ:{" "}
            </Typography>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              1402/12/04 - 10:35
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              شماره هوشمند وسیله نقلیه:{" "}
            </Typography>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              5555555
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              روش پرداخت:{" "}
            </Typography>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              بانک سامان
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
